export const PAGES = {
  LOGIN: '/login',
  HOME: '/',
  TURN_AROUND: '/turn-around',
}
